'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _analytics;

exports.isLoaded = isLoaded;
exports.loadTripAvailability = loadTripAvailability;
exports.loadUserAvailability = loadUserAvailability;
exports.loadLimitedCalendar = loadLimitedCalendar;
exports.loadPlainCalendar = loadPlainCalendar;
exports.setDay = setDay;
exports.selectDay = selectDay;
exports.selectDayMultiple = selectDayMultiple;
exports.selectRange = selectRange;
exports.setAvailabilityDay = setAvailabilityDay;
exports.clearRange = clearRange;
exports.setError = setError;

var _calendar = require('utils/calendar');

var _redux = require('redux');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var LOAD_TRIP_AVAIL = 'redux-frontend/calendar/LOAD_TRIP_AVAIL';
var LOAD_TRIP_AVAIL_SUCCESS = 'redux-frontend/calendar/LOAD_TRIP_AVAIL_SUCCESS';
var LOAD_TRIP_AVAIL_FAIL = 'redux-frontend/calendar/LOAD_TRIP_AVAIL_FAIL';

var LOAD_USER_AVAIL = 'redux-frontend/calendar/LOAD_USER_AVAIL';
var LOAD_USER_AVAIL_SUCCESS = 'redux-frontend/calendar/LOAD_USER_AVAIL_SUCCESS';
var LOAD_USER_AVAIL_FAIL = 'redux-frontend/calendar/LOAD_USER_AVAIL_FAIL';

var LOAD_PLAIN_CALENDAR = 'redux-frontend/calendar/LOAD_PLAIN_CALENDAR';
var LOAD_LIMITED_CALENDAR = 'redux-frontend/calendar/LOAD_LIMITED_CALENDAR';

var SET_DAY = 'redux-frontend/calendar/SET_DAY';
var SELECT_DAY = 'redux-frontend/calendar/SELECT_DAY';
var SELECT_DAY_MULTIPLE = 'redux-frontend/calendar/SELECT_DAY_MULTIPLE';
var SELECT_RANGE = 'redux-frontend/calendar/SELECT_RANGE';
var SELECT_AVAIL_DAY = 'redux-frontend/calendar/SELECT_AVAIL_DAY';
var CLEAR_RANGE = 'redux-frontend/calendar/CLEAR_RANGE';
var SET_ERROR = 'redux-frontend/calendar/SET_ERROR';

var SAVE_AVAIL_SUCCESS = 'redux-frontend/availability/SAVE_AVAIL_SUCCESS';

var initialState = {
  loaded: false,
  loading: false,
  dirty: false
};

var tripAvailability = function tripAvailability() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_TRIP_AVAIL:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_TRIP_AVAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case LOAD_TRIP_AVAIL_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
};

var userAvailability = function userAvailability() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_USER_AVAIL:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_USER_AVAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case LOAD_USER_AVAIL_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case SAVE_AVAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        dirty: false
      });
    case SELECT_AVAIL_DAY:
      if (!state.loaded) return (0, _extends3.default)({}, state);
      var data = JSON.parse((0, _stringify2.default)(state.data));
      var checkDay = function checkDay(day) {
        if (day.date && (0, _momentTimezone2.default)(action.date).isSame(day.date, 'day')) {
          return (0, _extends3.default)({}, day, {
            status: day.status === action.mode ? 'ask' : action.mode
          });
        }
        return day;
      };
      data[0].days = data[0].days.map(checkDay);
      data[1].days = data[1].days.map(checkDay);
      return (0, _extends3.default)({}, state, {
        data: data,
        dirty: true
      });
    default:
      return state;
  }
};

var plain = function plain() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_PLAIN_CALENDAR:
      return (0, _extends3.default)({}, state, {
        calendar: action.calendar,
        loaded: true
      });
    default:
      return state;
  }
};

var limited = function limited() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_LIMITED_CALENDAR:
      return (0, _extends3.default)({}, state, {
        calendar: action.calendar,
        loaded: true
      });
    default:
      return state;
  }
};

var selected = function selected() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { step: 0, days: [] };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_DAY:
      return (0, _extends3.default)({}, state, {
        day: action.date
      });
    case SELECT_DAY:
      return (0, _extends3.default)({}, state, {
        day: action.date,
        instant: action.instant,
        error: false
      });
    case SELECT_DAY_MULTIPLE:
      return (0, _extends3.default)({}, state, {
        days: (0, _calendar.toggleDate)(state.days, action.date)
      });
    case CLEAR_RANGE:
      return (0, _extends3.default)({}, state, {
        step: 0,
        range: null
      });
    case SET_ERROR:
      return (0, _extends3.default)({}, state, {
        error: action.error
      });
    case SELECT_RANGE:
      if (state.step === 0) {
        return (0, _extends3.default)({}, state, {
          step: state.step + 1,
          range: [action.date, action.date]
        });
      }
      return (0, _extends3.default)({}, state, {
        step: 0,
        range: [state.range[0], action.date]
      });
    default:
      return state;
  }
};

exports.default = (0, _redux.combineReducers)({
  tripAvailability: tripAvailability,
  userAvailability: userAvailability,
  plain: plain,
  selected: selected,
  limited: limited
});
var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, SELECT_DAY, function () {
  return { name: 'Select Day (Single)', category: 'Calendar' };
}), (0, _defineProperty3.default)(_analytics, SELECT_DAY_MULTIPLE, function () {
  return { name: 'Select Day (Multiple)', category: 'Calendar' };
}), (0, _defineProperty3.default)(_analytics, SELECT_RANGE, function () {
  return { name: 'Select Day (Range)', category: 'Calendar' };
}), (0, _defineProperty3.default)(_analytics, SELECT_AVAIL_DAY, function () {
  return { name: 'Select Day (Avail)', category: 'Calendar' };
}), _analytics);

function isLoaded(globalState) {
  return globalState.calendar && globalState.calendar.loaded;
}

function loadTripAvailability(trip, month) {
  var ticketIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var queryMonth = month ? month : (0, _calendar.getCurrentMonth)();
  // Use .locale() instead of deprecated .lang()
  var formattedMonth = (0, _momentTimezone2.default)(queryMonth, 'MMMM YYYY').locale('en').format('MMMM YYYY');
  var url = '/availability/calendar?trip_id=' + trip._id + '&month=' + formattedMonth + (ticketIds.length > 0 ? '&ticket_ids=' + ticketIds.join(',') : '');
  return {
    types: [LOAD_TRIP_AVAIL, LOAD_TRIP_AVAIL_SUCCESS, LOAD_TRIP_AVAIL_FAIL],
    promise: function promise(client) {
      return client.get(url).then(function (availabilities) {
        return (0, _calendar.generateCalendar)(month, trip, availabilities);
      }).catch(function (error) {
        throw error;
      });
    }
  };
}

function loadUserAvailability(month) {
  var thisMonth = month ? month : (0, _calendar.getCurrentMonth)();
  var nextMonth = (0, _calendar.getNextMonth)(thisMonth);
  return {
    types: [LOAD_USER_AVAIL, LOAD_USER_AVAIL_SUCCESS, LOAD_USER_AVAIL_FAIL],
    promise: function promise(client) {
      return _promise2.default.all([client.get('/availability/calendar', {
        params: { month: thisMonth }
      }).then(function (availabilities) {
        return _promise2.default.resolve((0, _calendar.generateCalendar)(thisMonth, null, availabilities));
      }), client.get('/availability/calendar', {
        params: { month: nextMonth }
      }).then(function (availabilities) {
        return _promise2.default.resolve((0, _calendar.generateCalendar)(nextMonth, null, availabilities));
      })]);
    }
  };
}

function loadLimitedCalendar(month, days) {
  var thisMonth = month ? month : (0, _momentTimezone2.default)(days[0]).format('MMMM YYYY');
  var availabilities = days.map(function (day) {
    return {
      date: day,
      status: 'selectable'
    };
  });
  return {
    type: LOAD_LIMITED_CALENDAR,
    calendar: (0, _calendar.generateCalendar)(thisMonth, null, availabilities)
  };
}

function loadPlainCalendar(month) {
  return {
    type: LOAD_PLAIN_CALENDAR,
    calendar: (0, _calendar.generateCalendar)(month)
  };
}

function setDay(date) {
  return {
    type: SET_DAY,
    date: date
  };
}

function selectDay(date) {
  var instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    type: SELECT_DAY,
    date: date,
    instant: instant
  };
}

function selectDayMultiple(date) {
  return {
    type: SELECT_DAY_MULTIPLE,
    date: date
  };
}

function selectRange(date) {
  return {
    type: SELECT_RANGE,
    date: date
  };
}

function setAvailabilityDay(date, mode) {
  return {
    type: SELECT_AVAIL_DAY,
    date: date, mode: mode
  };
}

function clearRange() {
  return {
    type: CLEAR_RANGE
  };
}

function setError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: SET_ERROR,
    error: error
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/calendar.js
// module id = 169
// module chunks = 47